import styled from 'styled-components';
import { Input as AtomInput } from 'components/atoms/input';
import { Box } from '../components';

export const Input = styled(AtomInput)`
  width: 100%;
`;

export const AddCategory = styled(Box)`
  gap: 0;
`;

export const Categories = styled(Box)`
  flex-direction: column;
  align-items: stretch;
  margin-top: var(--layout-01);
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 40px;
`;
